import { render } from "./HomeBottomCta.vue?vue&type=template&id=39472e14&scoped=true"
const script = {}

import "./HomeBottomCta.vue?vue&type=style&index=0&id=39472e14&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39472e14"

export default script